import { html, css } from 'lit';
import { classMap } from 'lit/directives/class-map';
import KaiElement from '../base';

class PillButtonElement extends KaiElement {
  static get is() {
    return 'kai-pillbutton';
  }

  static get properties() {
    return {
      icon: { type: String },
      text: { type: String },
      disabled: { type: Boolean },
      level: { type: String },
      apply: { type: String },
    };
  }

  static get styles() {
    return [
      super.styles,
      css`
        .container {
          display: inline;
        }

        button {
          outline: none;
          transition: all 0.3s;
        }

        .pill {
          width: var(--pillbutton-width, 32rem);
          height: var(--pillbutton-height, 6rem);
          border: none;
          border-radius: 3rem;
          padding: 0 2rem;
          display: flex;
          justify-content: center;
          align-items: center;
        }

        span {
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        }

        .secondary {
          background: var(--button-background-color, var(--color-gs00));
          border: 0.2rem solid var(--color-gs80);
          color: var(--secondary-font-color, var(--color-gs100));
        }

        .secondary:active {
          background: var(--pillbutton-active-background-secondary);
        }

        .secondary:disabled {
          border: 0.2rem solid var(--color-gs20);
          background: var(--color-gs00);
          pointer-events: none;
        }

        .primary {
          background: var(--button-background-color, var(--theme-color));
          color: var(--primary-font-color, var(--color-gs100));
        }

        .primary:active {
          background: var(--theme-color-d);
        }

        .primary:disabled {
          border: none;
          background: var(--color-gs20);
          pointer-events: none;
        }

        .secondary:disabled > span,
        .secondary:disabled > i,
        .primary:disabled > span,
        .primary:disabled > i {
          opacity: 0.5;
        }

        .btn {
          font-size: 3.2rem;
        }
      `,
    ];
  }

  constructor() {
    super();
    this.icon = '';
    this.level = 'primary';
    this.apply = '';
    this.disabled = false;
  }

  _onClick(e) {
    if (this.disabled) {
      e.stopImmediatePropagation();
    }
  }

  render() {
    const buttonClasses = {
      pill: true,
      [this.level]: true,
      h4: this.apply !== 'notification',
      h5: this.apply === 'notification',
      'dark-fixed': this.level === 'primary',
    };

    return html`
      <div class="container" @click="${this._onClick}">
        <button
          class="${classMap(buttonClasses)}"
          ?disabled="${this.disabled}"
          aria-label="${this.text ? this.text : this.icon}"
        >
          <span dir="auto">${this.text}</span>
          ${this.icon
            ? html` <i class="btn" data-icon="${this.icon}"></i> `
            : ''}
        </button>
      </div>
    `;
  }
}

customElements.define(PillButtonElement.is, PillButtonElement);
